<template>
  <longdo-map :location="mapCenter" :zoom="15" :lastView="false">
    <longdo-map-marker
      v-for="(item, i) in markers"
      :key="i"
      :location="item.location"
      :title="item.title"
      :detail="item.detail"
    />
  </longdo-map>
</template>

<script>
export default {
  name: 'PropMap',
  props: {
    markers: Array,
    mapCenter: Object
  }
}
</script>

<style scoped>
</style>
